import { useCallback, useRef, useState } from 'react'

import { AnimationContext, type AnimationContextValue } from '@components/storeMap/floor/3d/AnimationContext'
import { isTestMode } from '@utils/env.ts'

import type { ReactNode } from 'react'

interface AnimationProviderProps {
  children: ReactNode
}

export function AnimationProvider({ children }: AnimationProviderProps) {
  const counterRef = useRef(0)
  const [shouldAnimate, setShouldAnimate] = useState(false)

  const requireAnimation = useCallback(() => {
    const wasZero = counterRef.current === 0
    counterRef.current++
    // Only trigger re-render when transitioning from 0 to 1
    if (wasZero) {
      setShouldAnimate(true)
    }
  }, [])

  const revokeAnimation = useCallback(() => {
    counterRef.current--
    // Only trigger re-render when transitioning to 0
    if (counterRef.current <= 0) {
      counterRef.current = 0
      setShouldAnimate(false)
    }
  }, [])

  const value: AnimationContextValue = {
    shouldAnimate: !isTestMode ? shouldAnimate : false,
    requireAnimation,
    revokeAnimation,
  }

  return (
    <AnimationContext.Provider value={value}>
      {children}
    </AnimationContext.Provider>
  )
}
